<template>
<div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/sale/quotes">{{ $t('sale_quote') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('sale_quote_preview') }}</li>
        </ol>
    <div class="x_header">
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> {{ $t('back') }}</button>
        <template v-if="!invoice.IsApproved">
            <router-link :to="{ name: 'sale_quote_update', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-pencil"></i> {{$t('edit')}}</router-link>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onApproval"><i class="fa fa-check"></i> {{ $t('approval') }}</button>
        </template>
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="print"><i class="fa fa-print"></i> {{ $t('print') }}</button>
    </div>
    <div class="x_body">
        <div class="card f_card">
            <div class="card-body">
                <h3 class="text-center" style="font-weight: bold;">{{$t('sale_quotation')}}</h3>
                <p class="text-center">{{$now().format('DD/MM/YYYY HH:mm A')}}</p>
                <div class="row">
                    <div class="col-sm-6">
                        <table class="table-print">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">{{ $t('customer') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.CustomerName}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 100px;">{{ $t('phone') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.Phone}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-sm-6">
                        <table class="table-print" align="right">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">{{$t('invoice_no')}}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.Num}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('date')}}</td>
                                    <td>:</td>
                                    <td>{{$format(invoice.Date, 'DD/MM/YYYY')}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-bordered table-sm no-bor">
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                    <th>ទំនិញសេវាកម្ម</th>
                                    <th class="text-center" style="width: 100px;">{{$t('qty')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('uom')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('unit_price')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('tax_line')}}(%)</th>
                                    <th class="text-right" style="width: 100px;">សរុប</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>{{ret.ItemName}}</td>
                                    <td class="text-center">{{ret.Quantity}}</td>
                                    <td class="text-center">{{ret.UomName}}</td>
                                    <td class="text-right">{{$money(ret.Price)}}</td>
                                    <td class="text-right">{{$money(ret.TaxLine)}}</td>
                                    <td class="text-right">{{$money(ret.SubTotal)}}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="6" class="text-right">{{$t('untax_amount')}}:</th>
                                    <th class="text-right">{{$money(invoice.GrandTotal)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="6" class="text-right">{{$t('taxes')}}:</th>
                                    <th class="text-right">{{$money(invoice.TaxVat)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="6" class="text-right">{{$t('total')}}:</th>
                                    <th class="text-right">{{$money(invoice.TotalAmount)}}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    export default {
        data: function(){
            return {
                invoice: {
                    IsApproved: true
                },
                lines: []
            }
        },
        created: function(){
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                let loading = this.$loading.show();
                this.$api().post('sale/quote/preview', { Id: id }).then(res => {
                    var data = res.data.Json;
                    this.invoice = data.Header;
                    this.lines = data.Lines;
                }).finally(function(){ loading.hide(); });
            }
        },
        methods: {
            print: function(){
                window.open('/print/sale/quote/' + this.invoice.Id, '_blank');
            },
            onApproval(){
                let id = this.$route.params.id;
                let loading = this.$loading.show();
                this.$api().post('sale/quote/approval', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.$router.go(-1);
                    }
                }).finally(function(){ loading.hide(); });
            }
        }
    }
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
</style>
